/**
 * @fileoverview Job Searches layout. Hosts the InfoTrack and Web search
 * sub-tabs (rendered in the sidebar). Body is just the active child route.
 */

import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/jobs/$jobId/searches",
)({
  component: JobSearchesLayout,
});

function JobSearchesLayout() {
  return <Outlet />;
}
